// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Kxy9","paramInput":"JobSimulator_paramInput__zY9xz","input":"JobSimulator_input__3Yvjh"};